import moment from "moment";
import { request } from "../../../backend";
import CreditCheckResult from "../../../models/CreditCheckResult";

/**
 * Performs a credit check.
 */
export async function creditCheck(ssn: string): Promise<{ result: CreditCheckResult, errors: string[] }> {
  const sanitizedSsn = sanitizeSsn(ssn);

  const birthYear = parseInt(sanitizedSsn.slice(0, 4));
  const age = moment().get("year") - birthYear;

  if (age > 78 || age < 24) {
    return { result: new CreditCheckResult({credibility: "2", status: "Ogiltig ålder"}), errors: ["Ogiltig ålder"] }
  }

  const { result, errors } = await request('/creditcheck', 'post', {
    ssn
  });

  if (result.credibility !== "1") {
    return { result: new CreditCheckResult(result), errors: ["Kunden gick inte igenom kreditupplysningen"] }
  }

  return { result: result ? new CreditCheckResult(result) : null, errors: errors || [] };
}

/**
 * Performs a fake credit check, for demo purposes.
 */
export async function creditCheckDemo(ssn: string): Promise<{ result: CreditCheckResult, errors: string[] }> {
  const sanitizedSsn = sanitizeSsn(ssn);

  const birthYear = parseInt(sanitizedSsn.slice(0, 4));
  const age = moment().get("year") - birthYear;

  if (age > 78 || age < 24) {
    return { result: new CreditCheckResult({credibility: "2", status: "Ogiltig ålder"}), errors: ["Ogiltig ålder"] }
  }

  const creditCheckResult = new CreditCheckResult({
    city: 'Gideå',
    street: 'Utveda 6',
    zip: '890 37',
    credibility: "1",
    firstName: 'Albert',
    lastName: 'Skrapare',
    ssn: sanitizedSsn,
    status: 'Godkänd',
    date: new Date()
  });

  if (creditCheckResult.credibility !== "1") {
    return { result: new CreditCheckResult(creditCheckResult), errors: ["Kunden gick inte igenom kreditupplysningen"] }
  }

  return { result: creditCheckResult, errors: [] };
}

function sanitizeSsn(ssn: string): string {
  if (typeof ssn !== 'string') {
    return ssn;
  }

  ssn = ssn.replace(/[^\d]/g, '');

  if (ssn.length === 10) {
    const shortBirthYear = parseInt(ssn.slice(0, 2));
    const shortCurrentYear = parseInt(moment().get("year").toString().slice(2, 4));

    if (shortBirthYear > shortCurrentYear) {
      ssn = "19" + ssn;
    } else {
      ssn = "20" + ssn;
    }
  }

  return ssn;
}